interface FormCardProps {
    title: string;
    children: React.ReactNode;
    className?: string;
    hint?: string;
}

export function FormCard({
    title,
    children,
    className = "",
    hint,
}: FormCardProps) {
    return (
        <div
            className={`bg-[#212226] border border-white/[0.07] rounded-[14px] p-4 sm:p-5 ${className}`}
        >
            <div className="flex items-center gap-2 mb-3.5">
                <h3 className="text-sm font-semibold text-[#F1F0EA]">{title}</h3>
                {hint && (
                    <span className="text-sm text-[#6B6C72] ml-auto">{hint}</span>
                )}
            </div>
            {children}
        </div>
    );
}
